import type { ReactNode } from "react";

export interface PageNoticeProps {
  readonly title: string;
  readonly children: ReactNode;
}

/**
 * A neutral, informational framing block for a published page whose numbers
 * need context the page itself does not carry.
 *
 * Deliberately *not* the amber `DemoNotice` tone: a page that already carries
 * the sanitizer's demo disclaimer would otherwise show two warning-coloured
 * blocks in a row, and the second stops being read.
 */
export function PageNotice({ title, children }: PageNoticeProps) {
  return (
    <aside
      className="rounded-lg border px-4 py-3"
      style={{
        borderColor: "var(--border)",
        backgroundColor: "var(--bg-elevated)",
      }}
      aria-label={title}
    >
      <p className="text-sm font-semibold" style={{ color: "var(--fg)" }}>
        {title}
      </p>
      <div
        className="mt-1.5 space-y-1.5 text-sm leading-relaxed"
        style={{ color: "var(--fg-muted)" }}
      >
        {children}
      </div>
    </aside>
  );
}
